export default "__VITE_ASSET__86adfb15__"